import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery, useSubscription } from 'urql';
import { GraphqlOperations } from '../../../logic/graphql/operations';
import { Notification, Query, Subscription } from '../../../logic/graphql/types/types';
import NotificationListItem from './notification-list-item';

const ListContainer = styled.div`
  margin: 0px 8px 0px 8px;
  height: calc(100% - 66px);
  overflow-y: auto;
  scroll-margin-right: 8px;
`;

const List = styled.ul`
  padding: 0px 12px 0px 12px;
  display: flex;
  flex-direction: column;
`;

const NotificationsList = (): JSX.Element => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [subscriptionNotifications, setSubsciptionNotifications] = useState<Notification[]>([]);
  const result = useQuery<Query>({
    query: GraphqlOperations.queries.get_notifications.queryString,
    variables: GraphqlOperations.queries.get_notifications.createVars(1, 15),
    requestPolicy: 'network-only',
  })[0];
  const { data } = result;

  useEffect(() => {
    if (data?.get_notifications?.notifications) {
      setNotifications([...notifications, ...data.get_notifications.notifications]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSubscription = (
    subscriptionNotifs: Notification[] = [],
    response: Subscription,
  ): Notification[] => {
    if (response && response.new_notification) {
      setSubsciptionNotifications([response.new_notification, ...subscriptionNotifications]);
      return [response.new_notification, ...subscriptionNotifs];
    }
    return subscriptionNotifs;
  };

  useSubscription(
    {
      query: GraphqlOperations.subscriptions.new_notification.subscriptionString,
    },
    handleSubscription,
  );

  const handleAutoReadSubscription = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    autoReads: boolean[] = [],
    response: Subscription,
  ): boolean[] => {
    if (response && response.auto_read_notification !== undefined) {
      return [];
    }
    return [];
  };

  useSubscription(
    {
      query: GraphqlOperations.subscriptions.auto_read_notification.subscriptionString,
    },
    handleAutoReadSubscription,
  );

  return (
    <ListContainer>
      <List>
        {subscriptionNotifications.map((n) => (
          <NotificationListItem key={n.id} notification={n} new />
        ))}
        {notifications.map((n) => (
          <NotificationListItem key={n.id} notification={n} />
        ))}
      </List>
    </ListContainer>
  );
};

export default NotificationsList;
